export const OPEN_LOADER = "OPEN_LOADER";

export const FALSE_LOADER = "FALSE_LOADER";

export const UPDATE_ALERT = "UPDATE_ALERT";

export const UPDATE_ALERT_CLOSE = "UPDATE_ALERT_CLOSE";
